'use client'

import useSWR from 'swr'

import fetchWithTimeout from '@/lib/utils/fetch-with-timeout'

const fetcher = (url: string) => fetchWithTimeout(url).then((res) => res.json())

export default function EventTerms() {
  const { data, error } = useSWR(
    `${process.env.NEXT_PUBLIC_WP_API_URL}/wp-json/jf-custom/v1/get-options`,
    fetcher,
    {
      revalidateOnFocus: false,
    },
  )

  if (!data) return null

  const termsText = data?.event_details_message ?? ''

  if (!termsText) {
    return null
  }

  return (
    <div className="w-full overflow-hidden rounded-md bg-theme p-px gradient-angle-[to_right] theme--gradient-light gradient--border">
      <div
        className="p--small w-full rounded-md bg-theme p-l text-fg theme--primary-50"
        dangerouslySetInnerHTML={{ __html: termsText }}
      />
    </div>
  )
}
